// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__0-sYo {
  height: 50vh;
  overflow-y: scroll;
}

.styles_container_button__mJgne{
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  width: 100%;
}

.styles_button_next__Wy4eF {
  background-color: #18316e !important;
  color: #ffffff !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  padding: .4rem 1.5rem !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.styles_button_next__Wy4eF:hover {
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_button_next_disable__wGd0m {
  background-color: #888888 !important;
  color: #ffffff !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  padding: .4rem 1.5rem !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}


.styles_button_back__0x8qD {
  background-color: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  padding: .4rem 1.5rem !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.styles_button_back__0x8qD:hover {
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_titulosConfirmacao__Mk70g {
  color: #18316e;
}`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhadoCliente/ConfirmarDados/styles.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;AACtC;;;AAGA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".container {\n  height: 50vh;\n  overflow-y: scroll;\n}\n\n.container_button{\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.button_next {\n  background-color: #18316e !important;\n  color: #ffffff !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  padding: .4rem 1.5rem !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n.button_next:hover {\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.button_next_disable {\n  background-color: #888888 !important;\n  color: #ffffff !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  padding: .4rem 1.5rem !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n\n.button_back {\n  background-color: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  padding: .4rem 1.5rem !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n.button_back:hover {\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.titulosConfirmacao {\n  color: #18316e;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__0-sYo`,
	"container_button": `styles_container_button__mJgne`,
	"button_next": `styles_button_next__Wy4eF`,
	"button_next_disable": `styles_button_next_disable__wGd0m`,
	"button_back": `styles_button_back__0x8qD`,
	"titulosConfirmacao": `styles_titulosConfirmacao__Mk70g`
};
export default ___CSS_LOADER_EXPORT___;
